import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Denounce } from '../../../core/models/denounce.model';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../core/state/app.reducer';
import { ToastrService } from 'ngx-toastr';
import * as fromComplaintsActions from '../../../pages/home/state/complaints.actions';


@Component({
	selector: 'app-see-all-comments',
	templateUrl: './see-all-comments.component.html',
	styleUrls: ['./see-all-comments.component.scss']
})
export class SeeAllCommentsComponent implements OnInit {

	public denounce: Denounce;

	constructor(
		private toastr: ToastrService,
		private store: Store<AppState>,
		private complaintsService: ComplaintsService,
		public dialogRef: MatDialogRef<SeeAllCommentsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit(): void {
		this.denounce = this.data.denounce
		this.denounce.op_comments = this.denounce.op_comments.reverse();
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	private updateComplaintOnStore(): void {
		this.store.dispatch(fromComplaintsActions.loadComplaints());
	}

	public deleteComment(datetime: any): void {
		this.complaintsService
			.delcommentComplaint(this.denounce._id, datetime)
			.subscribe((r) => {
				// reload page
				this.getDenounceUpdateComments(this.denounce._id)
				this.updateComplaintOnStore();
				this.toastr.success('Comentário removido com sucesso.');
			});
	}

	getDenounceUpdateComments(id: string): void {
		this.complaintsService.getDenounce(this.denounce._id).subscribe((denounce: Denounce) => {
			this.denounce.op_comments = denounce.op_comments
			this.denounce = denounce
			this.denounce.op_comments = this.denounce.op_comments.reverse();

		});
	}

}
